import { createContext } from 'react';

export const HambugerMenuHistoryContext = createContext(null);
